import { render } from "./VsRow.vue?vue&type=template&id=051e2751"
import script from "./VsRow.vue?vue&type=script&lang=js"
export * from "./VsRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__